import axios from 'axios';
const baseURL='https://ill-red-dalmatian-suit.cyclic.app/';
const localbaseURL='http://localhost:8080/';

const signIn = async(userData,browserToken)=>{
    debugger
    let data;
    if (browserToken) {
        data = {
            email: userData,
            browser_token: browserToken
        }
    }
    else {
        data = { email: userData }
    }
    const user = await axios.post(`${baseURL+'signup'}`,data);
    return user;
}

export {signIn}